"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    // onInit(form: FormInterface) {
    // },
    onSuccess(form) {
        alert('### see console');
        console.log('Form Values', form.values());
    },
    onError(form) {
        alert('### see console');
        console.log('Form Errors', form.errors());
    },
    onSubmit(form) {
        console.log('-> onSubmit HOOK -', form.path || 'form', '- isValid?', form.isValid);
    },
    onClear(form) {
        console.log('-> onClear HOOK -', form.path || 'form');
    },
    onReset(form) {
        console.log('-> onReset HOOK -', form.path || 'form');
    },
    onChange(form) {
        console.log('-> onChange HOOK on Form: ', form.name);
    },
};
